__turbopack_context__.v({
  "emptyCard": "LeaderboardEmptyState-module__olWHrW__emptyCard" + " " + __turbopack_context__.i(917291)["lbRadialStroke"] + " " + __turbopack_context__.i(917291)["lbStrokeCard"] + " " + __turbopack_context__.i(917291)["lbCardBlur"] + " " + __turbopack_context__.i(917291)["lbCardBg"],
  "message": "LeaderboardEmptyState-module__olWHrW__message",
  "title": "LeaderboardEmptyState-module__olWHrW__title",
});
